module.exports = __webpack_public_path__ + "static/lights36-2e660e611d4067f110908c762a39ce0c.jpg";